export interface TariffCodeCompanyRequestEntity {
    companines: string[] | null;
}

export const EMPTY_TARIFF_CODE_COMPANY_REQUEST_ENTITY : TariffCodeCompanyRequestEntity = {
    companines: null
}